import { isPlainObject, isString } from 'lodash-es';
import { urlCombine, toQueryString } from '@/utils/url';
import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { deepTraverse } from '@ygtechnologies/rubus-frontend-utilities';
import { getStore } from '@/store';

function isPrimitive(value: any) {
    return (typeof value !== 'object' && typeof value !== 'function') || value === null;
}

export function getApiUrl(): string {
    return window['APP_CONFIG']['API_URL'];
}

export function getCoreApiUrl() {
    return window.APP_CONFIG.API_CORE_URL;
}

export function getChatApiUrl() {
    return window.APP_CONFIG.API_CHAT_URL;
}

function generateQueryString(data: object, includeLocale = true): string {
    const state = getStore().getState();

    if (includeLocale && state.global.currentCulture) {
        data = { ...data, __lang: state.global.currentCulture.locale };
    }

    return toQueryString(data);
}

export function generateApiUrl(relativePath: string, query: object = {}, includeLocale = true) {
    const queryString = generateQueryString(query, includeLocale);

    let url = getApiUrl() + relativePath;

    if (queryString) {
        url += '?' + queryString;
    }

    return url;
}

let errorHandler;
export function setAjaxErrorHandler(handler) {
    errorHandler = handler;
}

function handleAjaxError(response) {
    if (errorHandler) {
        errorHandler(response);
    }
}

export function jsonOrEmpty(body) {
    return body.text().then((text) => {
        return text ? JSON.parse(text) : null;
    });
}

function getDefaultParams(): Partial<RequestParameters> {
    const state = getStore().getState();

    return {
        credentials: 'include',
        headers: {
            'Bygr-Locale': state.global.currentCulture ? state.global.currentCulture.locale : '',
        },
    };
}

type RequestParameters = RequestInit & {
    query?: object;
    json?: boolean;
    body: any;
    disableGlobalError?: boolean;
};

// class ExtendedPromise<T> {
//     _promise: Promise<T>;
//     constructor(promise: Promise<T>) {
//         this._promise = promise;
//     }

//     catch<TResult = never>(
//         onrejected?: ((reason: any) => TResult | PromiseLike<TResult>) | undefined | null
//     ): ExtendedPromise<T | TResult> {
//         return new ExtendedPromise(this._promise.catch(onrejected));
//     }

//     then<TResult1 = T, TResult2 = never>(
//         onfulfilled?: ((value: T) => TResult1 | PromiseLike<TResult1>) | undefined | null,
//         onrejected?: ((reason: any) => TResult2 | PromiseLike<TResult2>) | undefined | null
//     ): ExtendedPromise<TResult1 | TResult2> {
//         return new ExtendedPromise(this._promise.then(onfulfilled, onrejected));
//     }

//     finally(onfinally?: (() => void) | undefined | null): ExtendedPromise<T> {
//         return new ExtendedPromise(this._promise.finally(onfinally));
//     }
// }

window.addEventListener('unhandledrejection', (e) => {
    const reason: Response = e.reason;
    if (reason && !reason.ok && reason.statusText) {
        handleAjaxError(e.reason.body);
    }
});

export async function request(url: string, params: Partial<RequestParameters> = {}, apiUrl: string | undefined = undefined) {
    params = {
        ...getDefaultParams(),
        ...params,
    };

    if (!params.headers) {
        params.headers = {};
    }

    let queryString = '';
    if (params.query && isPlainObject(params.query)) {
        queryString = toQueryString(params.query, { excludeEmptyArrays: true, excludeEmptyStrings: true });
    } else if (isString(params.query)) {
        queryString = params.query;
    }

    if (!/^(https?:)?\/\//gi.test(url)) {
        url = urlCombine(apiUrl ? apiUrl : getApiUrl(), url);

        if (!/^(https?:)?\/\//gi.test(url)) {
            url = '/' + url;
        }
    }

    if (queryString) {
        url += '?' + queryString;
    }

    if (
        isPlainObject(params.body) ||
        Array.isArray(params.body) ||
        isPrimitive(params.body) ||
        params.body instanceof FileData
    ) {
        await Promise.all(getAllPromises(params.body));

        if (params.body) {
            params.body = params.json ? JSON.stringify(params.body) : toQueryString(params.body as object);
        }
    }

    if (params.json) {
        params.headers['Content-Type'] = 'application/json';
    }

    delete params.query;
    delete params.json;

    let promise = fetch(url, params);

    promise = promise.then((response) => {
        if (!response.ok) {
            return Promise.reject(response);
        }

        return response;
    });

    return promise;
}


// function makeAbortable(promise) {
//     new Promise

//     promise.controller = new AbortController();

//     promise.abort = function () {
//         this.controller.abort();
//     }

//     function passAbortable(func) {
//         return function (...args) {
//             makeAbortable(func(...args));
//         }
//     }

//     ["then", "catch", "finally"].forEach(functionName => {
//         promise[functionName] = passAbortable(promise[functionName]);
//     });

//     return promise;
// }

function getAllPromises(obj: any): Promise<any>[] {
    var promises: Promise<any>[] = [];
    deepTraverse(obj, (val) => {
        // if (isPromise(val)) {
        //     promises.push(val);
        // }

        if (val instanceof FileData) {
            const promise = val.getDataPromise();
            if (promise) {
                promises.push(promise);
            }
        }
    });

    return promises;
}
